
export const BaseServiceURLs = {

  WEB_URL: "https://api.fortuna45.com/",
  BASE_URL: "https://api.fortuna45.com/",
  REPORTS_BASE_URL: "https://api.fortuna45.com/",
  FRONTEND_BASE_URL: "https://www.kurdbetdax200.com/",
  /*
 
   WEB_URL: "https://dev.5maxwin2000.com/",
 BASE_URL: "https://dev.5maxwin2000.com/",
 REPORTS_BASE_URL:"https://dev.5maxwin2000.com/",


 WEB_URL: "https://api.fortuna45.com/",
 BASE_URL: "https://api.fortuna45.com/",
 REPORTS_BASE_URL:"https://api.fortuna45.com/",
 
 */

  WS_BASE_URL: "api.fortuna45.com",
  SOCKET_URL: "https://sock.fortuna45.com",

  PRAGMATIC_CASINO_ID: "ppcse00000006201",
  PRAGMATIC_CASINO_LIVE: "dga.pragmaticplaylive.net",

  DEFAULT_PUBLIC_GAMER_SETTINGS_ID: "69889edb009d9096f3a0f50b",

  /** Cloudflare Turnstile site key (Dashboard'dan alın: https://dash.cloudflare.com/?to=/:account/turnstile) */
  TURNSTILE_SITE_KEY: "0x4AAAAAACXtDIhcW0fLY3TF",
};

/*
export const BaseServiceURLs = {
 WEB_URL: "https://www.maxbetone.com/",
 BASE_URL: "https://api.maxbetone.com/",
 REPORTS_BASE_URL:"https://reports.maxbetone.com/",
 WS_BASE_URL: "api.maxbetone.com",
 SOCKET_URL: "wss://socket.maxbetone.com",

 PRAGMATIC_CASINO_ID: "ppcph00000006199",
 PRAGMATIC_CASINO_LIVE: "dga.pragmaticplaylive.net",
};


*/
//DEV DETROIDsapi-dev.maxwin2000.com
export const detroidVirtualGames = [
  {
    provider: "LEAP",
    data: [
      "a57fa019b2a58f1eda38c11e93fa0722",
      "0dc8aeed1c5b7e2462d2f3b36c550af8",
      "8a156407ddbaf7848ea94264517854f9",
      "2aa3128fb55d4332eedcbb8bdcd39fc3",
      "0ecde3e3c597d32ad6ef0f1346c4aecf",
    ],
  },
  {
    provider: "RACING",
    data: [
      "e98a7d090641f9e8e8753278ce6a565c",
      "db44a9dfdcc485b6919d37de45200c37",
    ],
  },
  {
    provider: "VIRTUAL",
    data: [
      "1f77d1656406dc7cef75ca893d8985f3",
      "9ce7bf0549cb47b36fe6333516000a52",
      "f88b592ffbafe7f0f06e181dcbe370a2",
      "d97e095f02a752c40a5f5c590ebbe4f9",
    ],
  },
];

export const detroidGames = [
  {
    provider: "SPRIBE",
    data: ["670bc0debe9a9a9228ac9548f39c0f69"],
  },
  {
    provider: "SUPER_KENO",
    data: [
      "7543792161a90a26e777ec22fcda4af5",
      "e838f9531b67a8cd19e7ed9d3e127e94",
    ],
  },
];

export const tvBetGameTypes = [
  "keno",
  "gameshow"
]

export const virtualGameTypes = [
  "virtual",
]

export const gamesGameTypes = [
  "instantgame",
  "interactivegame",
  "crashgame",
  "dice"
]

export const createPermissionKey = (providerValue, _middleware, _type = '_CASINO_ACCESS') => {
  // Normal pattern
  let permissionKey = providerValue
    .toUpperCase()
    .replace(/-/g, '_')
    .replace(/\s/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');

  let _middlewareKey = _middleware
    .toUpperCase()
    .replace(/-/g, '_')
    .replace(/\s/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');

    if(_middleware == 'gasea'){
      permissionKey = `${permissionKey}${_type}`;
    }else{
      permissionKey = `${_middlewareKey}_${permissionKey}${_type}`;
    }


 // permissionKey = `${_middlewareKey}_${permissionKey}${_type}`;

  return permissionKey;
};

export const checkGameType = (x) => {
  if (x._midleware == 'innova') {
    if (gamesGameTypes.some(y => y == x.type)) {
      return providerTypes[5]._id;
    } else if (virtualGameTypes.some(y => y == x.type)) {
      return providerTypes[3]._id;
    } else if (tvBetGameTypes.some(y => y == x.type)) {
      return providerTypes[2]._id;
    } else if (x.type == 'live-casino' || x.subtype == 'live-casino') {
      return providerTypes[1]._id;
    } else {
      return providerTypes[0]._id;
    }
  } else if (x._midleware == 'matgame') {
    if (x.game_type == 2) {
      return providerTypes[1]._id;
    }
    else if (x.uniq_provider == 'vivolive') {
      return providerTypes[1]._id;
    }
    else if (x.lower_key == 'spaceman' || x.lower_key == 'aviatrix' || x.lower_key == 'jetx') {
      return providerTypes[5]._id;
    } else if (x.lower_key == 'goldenrace') {
      return providerTypes[3]._id;
    } else {
      return providerTypes[0]._id;
    }
  }
  else if (x._midleware == 'gasea') {
    if (x.categoryCode.toLowerCase().includes('slots')) {
      return providerTypes[0]._id;
    }
    else if (x.categoryCode.toLowerCase().includes('live')) {
      return providerTypes[1]._id;
    }
    else if (x.categoryCode.toLowerCase().includes('poker')) {
      return providerTypes[1]._id;
    }
    else if (x.categoryCode.toLowerCase().includes('mini')) {
      return providerTypes[5]._id;
    }
    else if (x.categoryCode.toLowerCase().includes('fish')) {
      return providerTypes[5]._id;
    }
    else {
      return providerTypes[5]._id;
    }
  } else {
    return providerTypes[0]._id;
  }

}

export const getReturnUrl = (type, data) => {

  switch (type) {
    case "69105da6f4acc097b5b9f6a1":
      return encodeURIComponent(`${BaseServiceURLs.FRONTEND_BASE_URL}casino/${data.vendor}`);
    case "69105da6f4acc097b5b9f6a2":
      return encodeURIComponent(`${BaseServiceURLs.FRONTEND_BASE_URL}live-casino/${data.vendor}`);
    case "69105da6f4acc097b5b9f6a3":
      return encodeURIComponent(`${BaseServiceURLs.FRONTEND_BASE_URL}tv-games/`);
    case "69105da6f4acc097b5b9f6a4":
      return encodeURIComponent(`${BaseServiceURLs.FRONTEND_BASE_URL}virtual/`);
    case "69105da6f4acc097b5b9f6a5":
      return encodeURIComponent(`${BaseServiceURLs.FRONTEND_BASE_URL}sports/`);
    case "69105da6f4acc097b5b9f6a6":
      return encodeURIComponent(`${BaseServiceURLs.FRONTEND_BASE_URL}games/`);
    default:
      return window.location.href;
  }
}

export const providerTypes = [
  {
    _id: "69105da6f4acc097b5b9f6a1",
    GameType: 'Casino',
    RecordID: 1
  },
  {
    _id: "69105da6f4acc097b5b9f6a2",
    GameType: 'Live Casino',
    RecordID: 2
  },
  {
    _id: "69105da6f4acc097b5b9f6a3",
    GameType: 'TV BET',
    RecordID: 3
  },
  {
    _id: "69105da6f4acc097b5b9f6a4",
    GameType: 'VIRTUAL',
    RecordID: 4
  },
  {
    _id: "69105da6f4acc097b5b9f6a5",
    GameType: 'SPORTS',
    RecordID: 5
  },
  {
    _id: "69123582d9b554ba2388c6b5",
    GameType: 'GAMES',
    RecordID: 6
  },
]